import { createDrawingObject, replaceLastPoint } from "../shared";
const Arc = {
    name: "arc",
    createDraft: (startPoint) => createDrawingObject("arc", [startPoint, startPoint, startPoint]),
    updateDraft: (draft, nextPoint) => replaceLastPoint(draft, nextPoint),
    render: () => undefined,
};
export default Arc;
